// Imports
import React from "react"
import { TagFilter } from "@molecules"
import { articleDateFormatter, estimateReading, classes } from "@utils"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ArticleParagraph } from "./article-paragraph"
import { ArticleList } from "./article-list"
import { ArticleCarousel } from "./article-carousel"
import { ArticleSocial } from "./article-social"

export const ArticleContent = ({ article }) => {
  const { title, published, filters, banner, articleBody } = article
  const { aC, aCB } = classes
  const img = getImage(banner.gatsbyImageData)
  const readingTime = estimateReading(articleBody)

  return (
    <article className={aC}>
      <div className={`${aC}__heading`}>
        <h1>{title}</h1>
        <div className={`${aC}__heading-sub`}>
          {filters && (
            <>
              {filters.map((filter, index) => (
                <TagFilter key={index} tag={filter} />
              ))}
              <span className="hr" />
            </>
          )}
          <span className="date">{articleDateFormatter(published)}</span>
          <span className="hr" />
          <span className="reading-time">{readingTime} perc olvasmány</span>
        </div>
        <GatsbyImage image={img} alt={title} />
      </div>
      <div className={aCB}>
        {articleBody.map((section, index) => {
          if (
            (section.text && section.text !== null) ||
            section.childContentfulArticleLeadLeadTextNode
          ) {
            return <ArticleParagraph key={index} content={section} />
          }
          if (section.list && section.list !== null) {
            return <ArticleList key={index} content={section} />
          }
          if (section.images) {
            return <ArticleCarousel key={index} content={section} />
          }
          return null
        })}
      </div>
      <div className={`${aC}__social`}>
        <hr />
        <ArticleSocial />
      </div>
    </article>
  )
}
